import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import {ConversionsReferenceDataService} from '../../services/conversions-reference-data.service';
import {Select2Option} from '../../../shared/select2-option';
import {IMultiSelectTexts, IMultiSelectOption, IMultiSelectSettings} from 'ngx-bootstrap-multiselect';
import {ConversionResidents} from '../../model/ConversionResidents';
import {SourceSession} from '../../model/SourceSession';
import {ActivatedRoute, NavigationExtras, Params, Router} from '@angular/router';
import {Location} from '@angular/common';
import {Subscription} from 'rxjs';
import {SelectedSessionDetails} from '../../model/SelectedSessionDetails';



@Component({
    selector: 're-start-doc-transfer',
    templateUrl: './start-doc-transfer.component.html',
    styleUrls: ['./start-doc-transfer.component.scss'],
    standalone: false
})
export class StartDocTransferComponent implements OnInit, OnDestroy {
  conversionForm: UntypedFormGroup;
  private sub: Subscription;
  conversionEnvironments: Select2Option[];
  conversionCorporations: Select2Option[];
  conversionFacilities: Select2Option[];
  conversionUnitsMulti: IMultiSelectOption[];
  conversionDocTypesMulti: IMultiSelectOption[];
  conversionResidents: ConversionResidents[] = [];
  loading: boolean;
  editSourceEnvironmentDetails: boolean;
  selectedResCount: number;
  dataTable: DataTables.Api;


  /*TODO use bootstrap multiselect (as recommended in NEO2 site). use either jquery library or an angular component if available */
  optionSettings: IMultiSelectSettings = {
    enableSearch: false,
    displayAllSelectedText: false,
    dynamicTitleMaxItems: 1,
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'form-control dropdown-toggle',
    containerClasses: 'ss-multiselect-dropdown',
  };

  optionTexts: IMultiSelectTexts = {
    checkAll: 'Select all',
    uncheckAll: 'Deselect all',
    checked: 'item selected',
    checkedPlural: 'items selected',
    searchPlaceholder: 'Search',
    defaultTitle: '',
    allSelected: 'All selected',
  };

  constructor(private conversionsReferenceDataService: ConversionsReferenceDataService,
              private router: Router,
              private route: ActivatedRoute,
              private location: Location,
              private fb: UntypedFormBuilder,
              private selectedSessionDetails: SelectedSessionDetails) {
  }

  ngOnDestroy(): void {
    delete window['currentComponent'];
    this.dataTable.destroy();
  }

  ngOnInit() {
    window['currentComponent'] = this;
    this.conversionForm = this.fb.group({
      sourceEnvironment: ['', Validators.required],
      sourceCorporation: ['', Validators.required],
      sourceFacility: ['', Validators.required],
      sourceUnits: [, Validators.required],
      sourceDocTypes: [, Validators.required],
      sourceDateRange: ['', Validators.required]
    });
    this.sub = this.route.queryParams.subscribe((params: Params) => {
      this.editSourceEnvironmentDetails = params['editSourceEnvironmentDetails'];
    });

    if (this.editSourceEnvironmentDetails) {
      this.conversionForm.get('sourceDateRange').setValue(this.selectedSessionDetails.enteredDateRange);
    }

    this.populateDataTable();
    this.getConversionEnvironments();

  }


  getConversionEnvironments() {
    if (this.editSourceEnvironmentDetails) {
      this.conversionForm.get('sourceEnvironment').setValue(this.selectedSessionDetails.selectedEnvId);
      this.getConversionCorporations();
    }
    this.conversionsReferenceDataService.getConversionEnvironments().subscribe(
      {
        next: x => this.conversionEnvironments = x.map(y => {
          return {id: y.environmentID.toString(), text: y.environmentKey}
        })
      });
  }

  getConversionCorporations() {
    this.resetFormFields();
    if (this.editSourceEnvironmentDetails) {
      this.conversionForm.get('sourceCorporation').setValue(this.selectedSessionDetails.selectedCorpId);
      this.getConversionFacilities();
    }
    this.conversionsReferenceDataService.getConversionCorporations(this.conversionForm.get('sourceEnvironment').value).subscribe(
      x => this.conversionCorporations = x.map(y => {
        return {id: y.corporationID.toString(), text: y.corpName}
      })
    );
  }

  resetFormFields() {
    this.conversionCorporations = [];
    this.conversionFacilities = [];
    this.conversionUnitsMulti = [];
    this.conversionDocTypesMulti = [];
    this.conversionForm.get('sourceCorporation').setValue(null);
    this.conversionForm.get('sourceFacility').setValue(null);
    this.conversionForm.get('sourceUnits').setValue(null);
    this.conversionForm.get('sourceDocTypes').setValue(null);
    /*$('#checkAllToggle').attr('checked', 'false');*/
    this.dataTable.clear();
    this.dataTable.draw();
  }

  getConversionFacilities() {
    const sourceEnvId = this.conversionForm.get('sourceEnvironment').value;
    const sourceCorporationId = this.conversionForm.get('sourceCorporation').value;
    this.conversionsReferenceDataService.getConversionFacilities(sourceEnvId, sourceCorporationId).subscribe(
      x => this.conversionFacilities = x.map(y => {
        return {id: y.facilityID.toString(), text: y.facilityName}
      })
    );

    if (this.editSourceEnvironmentDetails) {
      this.conversionForm.get('sourceFacility').setValue(this.selectedSessionDetails.selectedFacId);
      this.getConversionUnits();
    }
  }

  getConversionUnits() {
    const sourceEnvId = this.conversionForm.get('sourceEnvironment').value;
    const facilityId = this.conversionForm.get('sourceFacility').value;
    if (this.editSourceEnvironmentDetails) {
      this.conversionForm.get('sourceUnits').setValue(this.selectedSessionDetails.selectedUnits);
    }
    this.getConversionDocumentTypes();
    this.conversionsReferenceDataService.getConversionUnits(sourceEnvId, facilityId).subscribe(
      x => this.conversionUnitsMulti = x.map(y => {
        return {id: y.patientGroupID, name: y.description}
      }));
  }

  getConversionDocumentTypes() {
    const sourceEnvId = this.conversionForm.get('sourceEnvironment').value;
    const facilityId = this.conversionForm.get('sourceFacility').value;
    this.conversionsReferenceDataService.getConversionDocumentTypes(sourceEnvId, facilityId).subscribe(
      x => this.conversionDocTypesMulti = x.map(y => {
        return {id: y.documentTypeID, name: y.documentType}
      }));
    if (this.editSourceEnvironmentDetails) {
      this.conversionForm.get('sourceDocTypes').setValue(this.selectedSessionDetails.selectedDocTypes);
      this.dataTable.clear();
      this.dataTable.rows.add(this.selectedSessionDetails.searchedResidents);
      this.dataTable.draw();
      if (this.selectedSessionDetails.checkAllToggleCheckbox) {
        $('#checkAllToggle').attr('checked', 'true');
      }
      for (let i = 0; i <= this.selectedSessionDetails.selectedResidentIds.length; i++) {
        const resID = this.selectedSessionDetails.selectedResidentIds[i];
        $('#resident_' + resID).attr('checked', 'true');
      }
      this.editSourceEnvironmentDetails = false;
    }
  }

  searchResidents() {
    this.loading = true;
    const sourceEnvId = this.conversionForm.get('sourceEnvironment').value;
    const facilityId = this.conversionForm.get('sourceFacility').value;
    const sourceUnits = this.conversionForm.get('sourceUnits').value;
    const sourceDocTypes = this.conversionForm.get('sourceDocTypes').value;
    const sourceDateRange = this.conversionForm.get('sourceDateRange').value;
    this.conversionsReferenceDataService.getConversionResidents(sourceEnvId, facilityId, sourceUnits, sourceDocTypes, sourceDateRange).subscribe(conversionResidents => {
        this.conversionResidents = conversionResidents;
        this.loading = false;
        this.dataTable.clear();
        this.dataTable.rows.add(this.conversionResidents);
        this.dataTable.draw();
      },
      error => {
        console.log('error:' + error);
        this.loading = false;
      });

  }

  populateDataTable() {
    this.dataTable = $('#residentList').DataTable({
      dom:
        '<"row"<"col-sm-12"f>>' +
        '<"row"<"col-sm-12"tr>>' +
        '<"row d-none d-sm-flex"<"col-sm-12"<"float-right"p><"float-right neo-dt-l"l>>>' +
        '<"row d-flex d-sm-none"<"col-sm-6"l><"col-sm-6"p>>' +
        '<"row float-right d-none d-sm-flex"<"col-sm-12"<"float-right neo-dt-i"i>>>' +
        '<"row d-flex d-sm-none"<"col-sm-12"i>>',
      pagingType: 'full_numbers',
      language: {
        'paginate': {
          'first': '<<',
          'previous': '<',
          'next': '>',
          'last': '>>',
        },
        emptyTable: 'No Matching Records Found.',
      },
      ordering: false,
      searching: true,
      paging: true,
      info: true,
      serverSide: false,
      columns: [
        {
          title: `<div class="form-check"><input title="Select All/None" type="checkbox" class="form-check-input position-static" aria-label="Toggle Check All" value="all" id="checkAllToggle" onclick="currentComponent.toggleCheckAll()"></div>`,
          render: (data: any, type: any, r: ConversionResidents) => {
            return `<div class="form-check" id="checkbox_${r.residentID}"><input type="checkbox" class="form-check-input position-static" aria-label="Resident_${r.residentID}" value="option${r.residentID}" id="resident_${r.residentID}" onclick="currentComponent.allChecked()"></div>`;
          }
        },
        {
          title: 'First Name', render: (data: any, type: any, r: ConversionResidents) => {
            return `<input type="hidden"  value="${r.gender}" id="gender_${r.residentID}"> ${r.firstName}`;
          }
        },
        {
          title: 'Last Name', render: (data: any, type: any, r: ConversionResidents) => {
            return `${r.lastName}`;
          }
        },
        {
          title: 'SSN', render: (data: any, type: any, r: ConversionResidents) => {
            return `${r.ssn}`;
          }
        },
        {
          title: 'Date Of Birth', render: (data: any, type: any, r: ConversionResidents) => {
            return `${r.dob}`;
          }
        },
        {
          title: 'MRN', render: (data: any, type: any, r: ConversionResidents) => {
            return `${r.mrn}`;
          }
        },
        {
          title: 'Unit', render: (data: any, type: any, r: ConversionResidents) => {
            return `${r.unit}`;
          }
        },
        {
          title: 'Documents Available', render: (data: any, type: any, r: ConversionResidents) => {
            return `${r.documentsCount}`;
          }
        },
      ]


    });
    new $.fn.dataTable['FixedHeader'](this.dataTable);
  }


  toggleCheckAll() {
    this.selectedSessionDetails.checkAllToggleCheckbox = true;
    let toggleCheck = <HTMLInputElement>document.querySelector('#checkAllToggle'); //hard eyeroll
    // https://www.typescriptlang.org/docs/handbook/basic-types.html#type-assertions
    let checkAll = toggleCheck.checked;

    let allCheckboxes = document.querySelectorAll('td .form-check-input');
    allCheckboxes.forEach(function (item) {
      let singleCheck = <HTMLInputElement>item; // hard eyeroll, again...
      singleCheck.checked = checkAll;
    })
  }

  allChecked() {
    let allChecked: boolean = true;
    let toggleCheck = <HTMLInputElement>document.querySelector('#checkAllToggle'); //hard eyeroll
    let allCheckboxes = document.querySelectorAll('td .form-check-input');
    allCheckboxes.forEach(function (item) {
      let singleCheck = <HTMLInputElement>item; //hard eyeroll
      if (!singleCheck.checked) {
        allChecked = singleCheck.checked;
      }
    })
    toggleCheck.checked = allChecked;
  }

  addDefaultOption(options: any[]): any {
    options.unshift({environmentID: null, environmentDescription: '- Not selected -'});
    return options;
  }


  saveRes() {
    let sourceSession = new SourceSession();
    let dtRows = this.dataTable.rows().nodes();
    let count = 0;
    dtRows.each(function (value, index) {
      let residents = new ConversionResidents();
      if ($(value).find('input[id^=\'resident_\']').is(':checked')) {
        let cols = value.children;
        let residentID = cols[0].lastChild.id.substring(9, cols[0].lastChild.id.length + 1);
        residents.firstName = cols[1].innerText;
        residents.lastName = cols[2].innerText;
        residents.ssn = cols[3].innerText;
        residents.dob = cols[4].innerText;
        residents.mrn = cols[5].innerText;
        residents.unit = cols[6].innerText;
        residents.documentsCount = cols[7].innerText;
        residents.residentID = residentID;
        residents.gender = $('#gender_' + residentID).val().toString();
        sourceSession.residents[count] = residents;
        count = count + 1;
      }
    });

    for (let i = 0; i < sourceSession.residents.length; i++) {

      this.selectedSessionDetails.selectedResidentIds.push(sourceSession.residents[i].residentID);
    }
    this.selectedResCount = count;
    sourceSession.sourceEnvironmentId = this.conversionForm.get('sourceEnvironment').value;
    sourceSession.sourceCorporationId = this.conversionForm.get('sourceCorporation').value;
    sourceSession.sourceFacilityId = this.conversionForm.get('sourceFacility').value;
    sourceSession.sourceUnitId = this.conversionForm.get('sourceUnits').value;
    sourceSession.sourceDocTypes = this.conversionForm.get('sourceDocTypes').value;
    sourceSession.dateRange = this.conversionForm.get('sourceDateRange').value;
    sourceSession.sourceEnvironmentName = $('#sourceEnvironment option:selected').text();
    sourceSession.sourceCorporationName = $('#sourceCorporation option:selected').text();
    sourceSession.sourceFacilityName = $('#sourceFacility option:selected').text();
    const sourceSessionObj = JSON.stringify(sourceSession);
    this.routeToDetailsPage(sourceSessionObj);
  }

  routeToDetailsPage(sourceSessionObj: string) {
    const sourceEnv = this.conversionForm.get('sourceEnvironment').value;
    const sourceCorpId = this.conversionForm.get('sourceCorporation').value;
    const sourceFacId = this.conversionForm.get('sourceFacility').value;

    const sourceUnitIds = this.conversionForm.get('sourceUnits').value.length;
    const sourceDocTypes = this.conversionForm.get('sourceDocTypes').value.length;
    const dateRange = this.conversionForm.get('sourceDateRange').value;
    const resCount = this.selectedResCount;
    const environments = this.conversionEnvironments;
    const sourceSession = sourceSessionObj;
    this.selectedSessionDetails.selectedEnvText = $('#sourceEnvironment option:selected').text();
    this.selectedSessionDetails.selectedCorpText = $('#sourceCorporation option:selected').text();
    this.selectedSessionDetails.selectedFacText = $('#sourceFacility option:selected').text();
    this.selectedSessionDetails.enteredDateRange = dateRange;
    this.selectedSessionDetails.selectedCorpId = sourceCorpId;
    this.selectedSessionDetails.selectedEnvId = sourceEnv;
    this.selectedSessionDetails.selectedFacId = sourceFacId;
    this.selectedSessionDetails.selectedUnits = this.conversionForm.get('sourceUnits').value;
    this.selectedSessionDetails.selectedDocTypes = this.conversionForm.get('sourceDocTypes').value;
    this.selectedSessionDetails.selectedSourceUnitsCount = sourceUnitIds;
    this.selectedSessionDetails.selectedSourceDocTypesCount = sourceDocTypes;
    this.selectedSessionDetails.selectedResidentCount = resCount;
    this.selectedSessionDetails.sourceSessionObj = sourceSession;
    this.selectedSessionDetails.searchedResidents = this.conversionResidents;

    /* send query params if want to retain them on page refresh as use singleton selectedSessionDetails object, signleton object doesn't retain values on page refresh
    const navigationExtras: NavigationExtras = {
      queryParams: {'sourceEnv': sourceEnv, 'sourceCorpId': sourceCorpId, 'sourceFacId': sourceFacId, 'sourceUnitIds': sourceUnitIds, 'sourceDocTypes': sourceDocTypes, 'dateRange': dateRange, 'sessionId': sessionId, 'resCount': resCount, 'sourceSession': sourceSession},
    };*/
    this.router.navigate(['/conversions/resident-doc-move/start/detail']);
  }

  goBack(): void {
    this.location.back();
  }

}
